import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function MemberRoute({ children }) {
  const { session, loading } = useAuth();
  const location = useLocation();

  if (!loading && !session) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ redirectTo: location.pathname }}
      />
    );
  }

  if (loading) {
    return (
      <div className="container py-5 text-center">
        <p className="text-muted mb-0">Loading…</p>
      </div>
    );
  }

  return children;
}
